"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberList = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var text_1 = require("utils/text");
var components_1 = require("./components");
var utils_1 = require("./utils");
require("./style.scss");
var headers = ['user', 'company', 'description', 'validity', 'edit', 'remove'];
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var data = (0, utils_1.filterCategories)(this.props.groups, this.props.searchString, this.props.filters, this.props.featureFilter);
        this.props.setItems((0, utils_1.mapData)(data, this.props.isCollapsed, this.props.permission & ~acl.FEATURE_MASK, this.props.disabled));
    },
    componentDidUpdate: function (prevProps) {
        var items = this.props.items;
        if ((prevProps.groups.length === 0 && this.props.groups.length) ||
            this.props.groups !== prevProps.groups ||
            (prevProps.status !== 'FETCHED' && this.props.status === 'FETCHED') ||
            this.props.searchString !== prevProps.searchString ||
            this.props.sortingAndPagination !== prevProps.sortingAndPagination ||
            this.props.filters !== prevProps.filters ||
            this.props.isCollapsed !== prevProps.isCollapsed ||
            this.props.featureFilter !== prevProps.featureFilter) {
            var data = (0, utils_1.filterCategories)(this.props.groups, this.props.searchString, this.props.filters, this.props.featureFilter);
            items = (0, utils_1.mapData)(data, this.props.isCollapsed, this.props.permission & ~acl.FEATURE_MASK, this.props.disabled);
            this.props.setItems(items);
        }
        if (items !== prevProps.items ||
            this.props.isCollapsed !== prevProps.isCollapsed) {
            var contentWidth_1 = 0;
            var columns_1 = items.reduce(function (p, item) {
                headers.forEach(function (x) {
                    var dataKey = '__' + x.replace(/-/g, '');
                    switch (x) {
                        case 'user': {
                            var length = 0;
                            if (item.type === 'USER') {
                                var name = (0, text_1.calculateStringLength)((0, utils_1.getName)(item.user));
                                var email = (0, text_1.calculateStringLength)(item.user.email);
                                length = (email > name ? email : name) + 2.3 * 13;
                            }
                            else {
                                length = (0, text_1.calculateStringLength)((0, utils_1.getGroupName)(item.group));
                            }
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'company': {
                            var length = 0;
                            if (item.type === 'USER') {
                                length = (0, text_1.calculateStringLength)(item.user.company || '');
                            }
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'description': {
                            var length = 0;
                            if (item.type === 'GROUP' || item.type === 'CATEGORY') {
                                length = (0, text_1.calculateStringLength)(item.group.description || '');
                            }
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'validity': {
                            var length = 0;
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                    }
                });
                return p;
            }, {});
            headers.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("userfront/project/teamMembers/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text);
                if (x === 'user' || x === 'company') {
                    length += 55;
                }
                if (!columns_1[dataKey] || columns_1[dataKey] < length) {
                    columns_1[dataKey] = length;
                }
            });
            // Override styles for dynamic classes
            var style = document.getElementById('ProjectTeamMembersListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'ProjectTeamMembersListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 6.25 * 13 + 6.75 * 13 + 5 * 13;
            Object.keys(columns_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + columns_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    }
})
// , pure
);
var component = function (props) {
    var itemData = (0, utils_1.createRowDataFromProps)(props);
    var allSelected = (0, utils_1.checkAllSelected)(props.items, props.selectedUsers, props.selectedGroups);
    return (React.createElement("div", { className: 'generic-member-list-container' },
        React.createElement("div", { className: 'sok-list-content generic-member-list ' + props.status.toLowerCase() },
            props.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(); } }))),
            props.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))),
            props.status === 'FETCHED' && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(components_1.Header, __assign({}, props, { allSelected: allSelected })), placeholder: React.createElement(components_1.NotFoundPlaceholder, { translations: props.translationKeys && props.translationKeys.notFound }) }, components_1.ListRow));
            })))));
};
exports.MemberList = enhance(component);
